module.exports = __webpack_public_path__ + "static/media/turks-and-caicos.7838c97e.svg";